
const navbar = document.querySelector(".navbar");
const backdrop = document.querySelector(".hide-header-img");
let imgToHide = document.querySelectorAll(".img-to-hide");
export default () => {
    if (backdrop){

        imgToHide.forEach(el =>{
            if(el.getBoundingClientRect().height > 0){
                imgToHide = el;
            }
        } );
        addBrToHeader();

        document.addEventListener('load', function(){
            backdrop.style.top = adjustTop() + "px";
        })

        document.addEventListener('scroll', function(){
            backdrop.style.top = adjustTop() + "px";
        })

        window.addEventListener('resize', function(){
            backdrop.style.top = adjustTop() + "px";
        })
    }
}
function addBrToHeader(){
    let cmtHeader = document.querySelector(".projects-project-details-header-content-wrapper .cmt-header");
    if(cmtHeader){
        let cmtHeaderText = cmtHeader.textContent;
        if (cmtHeaderText.includes(",")) {
            let newText = cmtHeaderText.split(",").join(",<br>");
            cmtHeader.innerHTML = newText;
        }
    }
}
function adjustTop(){
    let scrollTop =(navbar.getBoundingClientRect().bottom + imgToHide.getBoundingClientRect().height) -$(window).scrollTop();

    if( scrollTop <= navbar.getBoundingClientRect().bottom){
        return navbar.getBoundingClientRect().bottom
    }

    return scrollTop;
}
